export default __webpack_public_path__ + "static/media/loading.2368aa58.gif";